export default __webpack_public_path__ + "static/media/plain-sticker-L.5c53d260.png";